import { render, staticRenderFns } from "./ContentDisplayLoader.vue?vue&type=template&id=a44d9e68&scoped=true"
import script from "./ContentDisplayLoader.vue?vue&type=script&lang=ts"
export * from "./ContentDisplayLoader.vue?vue&type=script&lang=ts"
import style0 from "./ContentDisplayLoader.vue?vue&type=style&index=0&id=a44d9e68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44d9e68",
  null
  
)

export default component.exports